// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getPublicAssets } from 'utils/assetsUtils';
import { DEFAULT_ICON_WIDTH, DEFAULT_BACKGROUND_URL } from 'constants/cardCompetitionConstant';

type Props = {
  title: string,
  icon: string,
  url: string,
  labelFooter: string,
  isSmall?: boolean,
  isLogged?: boolean,
  hasClub?: boolean,
  isHomePage?: boolean,
  desc: {
    icon: string,
    text: string
  },
  clubs: Array<{ label: string, logo: string }>
};

let iconWidth = DEFAULT_ICON_WIDTH;
let backgroundUrl = DEFAULT_BACKGROUND_URL;

class CardCompetition extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    title: 'Compétitions',
    icon: '/img/logo/ffr_white.svg',
    labelFooter: 'Accéder au site',
    url: 'https://competitions.ffr.fr/',
    desc: {
      icon: 'icon-shield-alt',
      text: 'Pour profiter pleinement de l’expérience FFR Compétitions, choisissez les clubs que vous supportez.'
    },
    clubs: []
  };

  renderItem = (): any => {
    return this.props.clubs.map((club, index) => {
      return (
        <li key={index} className="ft-truncat">
          <img src={club.logo} alt={club.label} width={24} />
          {club.label}
        </li>
      );
    });
  };

  render() {
    const { url, hasClub, isLogged, isSmall, icon, title, labelFooter, isHomePage } = this.props;
    const classNamesContainer = dynamicClassName('col');
    const classNamesLink = dynamicClassName('box card card--competition');
    const classNamesIcon = dynamicClassName('icon');
    isHomePage ? classNamesContainer.add('col-md12 col-lg-3 mb-2') : classNamesContainer.add('col-md-4 col-lg-3');

    if (isLogged) {
      classNamesLink.add('is-logged');
      iconWidth = 32;
      backgroundUrl = '/img/card/bg-competition-noclub.jpg';
    }

    if (hasClub) {
      classNamesLink.add('has-club is-logged');
      iconWidth = 32;
      backgroundUrl = '/img/card/bg-competition-club.jpg';
    }

    isSmall && classNamesLink.add('card--small');
    this.props.desc.icon && classNamesIcon.add(this.props.desc.icon);
    return (
      <div className={classNamesContainer.build()}>
        <a href={url} rel="noopener noreferrer" target="_blank" className={classNamesLink.build()}>
          <div className="card__thumbnail" style={{ backgroundImage: `url(${getPublicAssets(backgroundUrl)})` }} />
          <div className="card__body">
            <img src={getPublicAssets(icon)} alt={''} width={iconWidth} />
            <h3 className="card__title">{title}</h3>
            <p className="card__desc ft-secondary">
              {isLogged && <i className={classNamesIcon.build()} />}
              {this.props.desc.text}
            </p>
            {hasClub && <ul className="ft-h5">{this.renderItem()}</ul>}
          </div>
          <div className="card__footer">
            <span className="link-chevron link-chevron--white">
              {labelFooter}
              <i className="icon icon-chevron-right" />
            </span>
          </div>
        </a>
      </div>
    );
  }
}

export default CardCompetition;
